import Vue from 'vue';

import rutFilter from '@/library/filters/rutFilter';
import moneyFilter from '@/library/filters/moneyFilter';
import milesFilter from '@/library/filters/milesFilter';

Vue.filter('formatRut', rutFilter)
Vue.filter('moneyFilter', moneyFilter)
Vue.filter('milesFilter', milesFilter)